import {environment} from "../../../../../environments/environment";

(function () {
    'use strict';

    angular
        .module('planInitiativeRoutes', [
            'planInitiativeEditModule'
        ])
        .config(router);

    router.$inject = ['$stateProvider', 'historyCtxtServiceProvider'];

    function router($stateProvider, historyCtxtServiceProvider) {

        $stateProvider

            .state('initiative', {
                url: '/Initiative',
                abstract: true,
                data: {
                    breadcrumb: {
                        title: 'Initiatives',
                        cssIcon: 'fa fa-search',
                        usingHistoryCtxt: true,
                        defaultCtxtState: 'newPlanInitiativeSearch'
                    }
                },
                views: {
                    '': {
                        template: '<div ui-view="breadcrumbs" class="breadcrumbs-container"></div><div ui-view="mainContent" class="business-planning"></div>'
                    },
                    'breadcrumbs@initiative': {
                        templateUrl: require('./initiativeBreadcrumbs.tpl.html')
                    }
                }
            })

             // Initiative Add
            .state('initiative.add', {
                url: '/Add',
                data: {
                    permissions: { featureRole: 'GRCBusinessPlanningManagement', key: 'PlanInitiative', permission: 'Edit' },
                },
                resolve: {
                    initiative: [function () {
                        return {};
                    }]
                },
                views: {
                    'mainContent@initiative': {
                        templateUrl: require('./InitiativeAdd.tpl.html'),
                        controller: 'InitiativeAddController'
                    }
                }
            })

            // Initiative Edit
            .state('initiative.edit', {
              url: '/{InitiativeID:int}',
              controllerProvider: ['$window', '$stateParams', function ($window, $stateParams) {
                let url = environment.pilotUrl + '/tps/initiative/' + $stateParams.InitiativeID;
                $window.open(url, '_blank');
                setTimeout(() => $window.history.back());
              }]
            })

            // Deliverable
            .state('initiative.edit.deliverable', {
                url: '/Deliverable',
                params: historyCtxtServiceProvider.getStateParamsConfig(),
                data: {
                    permissions: { featureRole: 'GRCBusinessPlanningManagement', key: 'PlanDeliverable', permission: 'View' },
                    breadcrumb: {
                        title: 'Milestones',
                        cssIcon: 'fa fa-inbox',
                    }
                },
                views: {
                    'mainContent@initiative': {
                        templateUrl: require('./deliverables.tpl.html'),
                        controller: 'InitiativeEditController'
                    }
                }
            })

            .state('initiative.edit.addDeliverable', {
                url: '/Deliverable/Add',
                params: historyCtxtServiceProvider.getStateParamsConfig(),
                data: {
                    permissions: { featureRole: 'GRCBusinessPlanningManagement', key: 'PlanDeliverable', permission: 'Edit' }
                },
                resolve: {
                    deliverable: ['initiative', function (initiative) {
                        return {
                            PlanInitiativeID: initiative.PlanInitiativeID,
                            PlanInitiative: initiative,
                            DeliverableTagList: []
                        };
                    }]
                },
                views: {
                    'mainContent@initiative': {
                        templateUrl: require('./deliverableEdit.tpl.html'),
                        controller: 'DeliverableEditController'
                    }
                }
            })

            .state('initiative.edit.deliverable.edit', {
                url: '/{PlanDeliverableID:int}',
                params: historyCtxtServiceProvider.getStateParamsConfig(),
                resolve: {
                    deliverable: ['$stateParams', 'businessPlanningService', function ($stateParams, businessPlanningService) {
                        return businessPlanningService.getInitiativeDeliverable($stateParams.InitiativeID, $stateParams.PlanDeliverableID);
                    }]
                },
                views: {
                    'mainContent@initiative': {
                        templateUrl: require('./deliverableEdit.tpl.html'),
                        controller: 'DeliverableEditController'
                    }
                }
            });

        // History Context
        historyCtxtServiceProvider.setCtxtState('initiative.edit',
            '/app/Main/search/GOVHistoryCtxtDirective-searchResults.tpl.html');
    }
})();
